(function() { window.GUID_c01d7c61_2289_4b62_b708_45e053fe3048 = { getGuid: function() { return "c01d7c61-2289-4b62-b708-45e053fe3048"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class SplashScreen extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
                let me = this;
                setTimeout(function () {
                    me.$Control.addClass('loaded');
                    setTimeout(function () {
                        me.$Control.remove();
                    }, 1000);
                }, 1000);
            }
            OnDispose() {
                this.$Control.remove();
            }
            OnBindEvents() { }
        }
        Controls.SplashScreen = SplashScreen;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=splashscreen.js.map
